module.exports = "<div class=\"app\">\r\n  <app-nav></app-nav>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n<footer class=\"app-footer\">\r\n  <div class=\"container\">\r\n    <ul class=\"app-footer__list\">\r\n      <li class=\"app-footer__list__item\">\r\n        <a [routerLink]=\"['/toegankelijkheid']\">Toegankelijkheid</a>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main